/*
 * @Descripttion: 
 * @version: 
 * @Author: Sam
 * @Date: 2020-05-11 15:24:36
 * @LastEditors: Sam
 * @LastEditTime: 2020-07-13 08:57:18
 */ 
import ZeroTree from '../plugins/zero-tree'
import '../plugins/zero-tree/zero-tree.min.css'
export default {
  install(Vue) {
    Vue.use(ZeroTree)
  },
}
